
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/me",
      function () {
        return require("private-next-pages/account/me.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/me"])
      });
    }
  